import { useTranslation } from 'react-i18next'

import { Box } from '@enechain/ecloud-designsystem'

import { CompactAlert } from '~/components/common/CompactAlert'

type Props = {
  /**
   * 据え置き件数と、何を直せば処理対象になるかの案内。design の `#noop-banner`
   * desc が data type ごとに異なるため呼び出し側の i18n で組み立てて渡す。
   */
  description: string
}

/**
 * CSV アップロード Step2 の「処理対象 0 件」バナー (common.md AC-DUC-033、
 * design `#noop-banner`)。title は AC が data type 横断で固定する文言なので
 * component 内で `common:` から解決する (page 別 key に複製しない、#4325)。
 * 表示するかどうかは `~/models/csvUploadConfirmGate` の判定に従い、呼び出し側が
 * 決める。
 */
export const CsvUploadNoopBanner = ({
  description,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <Box marginBottom={3}>
      <CompactAlert
        description={description}
        status="info"
        title={t('common:upload.noop.title')}
      />
    </Box>
  )
}
